import { render, staticRenderFns } from "./SIP-Client.vue?vue&type=template&id=45a4e02d&"
import script from "./SIP-Client.vue?vue&type=script&lang=js&"
export * from "./SIP-Client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports